/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetToolVariationsGroupRequestBody,
  SetToolVariationsGroupRequestBody$Outbound,
  SetToolVariationsGroupRequestBody$outboundSchema,
} from "../components/settoolvariationsgrouprequestbody.js";

export type SetToolsetToolVariationsGroupSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type SetToolsetToolVariationsGroupSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type SetToolsetToolVariationsGroupSecurity = {
  option1?: SetToolsetToolVariationsGroupSecurityOption1 | undefined;
  option2?: SetToolsetToolVariationsGroupSecurityOption2 | undefined;
};

export type SetToolsetToolVariationsGroupRequest = {
  /**
   * The slug of the toolset to configure
   */
  slug: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  setToolVariationsGroupRequestBody: SetToolVariationsGroupRequestBody;
};

/** @internal */
export type SetToolsetToolVariationsGroupSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const SetToolsetToolVariationsGroupSecurityOption1$outboundSchema:
  z.ZodMiniType<
    SetToolsetToolVariationsGroupSecurityOption1$Outbound,
    SetToolsetToolVariationsGroupSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function setToolsetToolVariationsGroupSecurityOption1ToJSON(
  setToolsetToolVariationsGroupSecurityOption1:
    SetToolsetToolVariationsGroupSecurityOption1,
): string {
  return JSON.stringify(
    SetToolsetToolVariationsGroupSecurityOption1$outboundSchema.parse(
      setToolsetToolVariationsGroupSecurityOption1,
    ),
  );
}

/** @internal */
export type SetToolsetToolVariationsGroupSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const SetToolsetToolVariationsGroupSecurityOption2$outboundSchema:
  z.ZodMiniType<
    SetToolsetToolVariationsGroupSecurityOption2$Outbound,
    SetToolsetToolVariationsGroupSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function setToolsetToolVariationsGroupSecurityOption2ToJSON(
  setToolsetToolVariationsGroupSecurityOption2:
    SetToolsetToolVariationsGroupSecurityOption2,
): string {
  return JSON.stringify(
    SetToolsetToolVariationsGroupSecurityOption2$outboundSchema.parse(
      setToolsetToolVariationsGroupSecurityOption2,
    ),
  );
}

/** @internal */
export type SetToolsetToolVariationsGroupSecurity$Outbound = {
  Option1?: SetToolsetToolVariationsGroupSecurityOption1$Outbound | undefined;
  Option2?: SetToolsetToolVariationsGroupSecurityOption2$Outbound | undefined;
};

/** @internal */
export const SetToolsetToolVariationsGroupSecurity$outboundSchema:
  z.ZodMiniType<
    SetToolsetToolVariationsGroupSecurity$Outbound,
    SetToolsetToolVariationsGroupSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(
        z.lazy(() =>
          SetToolsetToolVariationsGroupSecurityOption1$outboundSchema
        ),
      ),
      option2: z.optional(
        z.lazy(() =>
          SetToolsetToolVariationsGroupSecurityOption2$outboundSchema
        ),
      ),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function setToolsetToolVariationsGroupSecurityToJSON(
  setToolsetToolVariationsGroupSecurity: SetToolsetToolVariationsGroupSecurity,
): string {
  return JSON.stringify(
    SetToolsetToolVariationsGroupSecurity$outboundSchema.parse(
      setToolsetToolVariationsGroupSecurity,
    ),
  );
}

/** @internal */
export type SetToolsetToolVariationsGroupRequest$Outbound = {
  slug: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SetToolVariationsGroupRequestBody: SetToolVariationsGroupRequestBody$Outbound;
};

/** @internal */
export const SetToolsetToolVariationsGroupRequest$outboundSchema: z.ZodMiniType<
  SetToolsetToolVariationsGroupRequest$Outbound,
  SetToolsetToolVariationsGroupRequest
> = z.pipe(
  z.object({
    slug: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    setToolVariationsGroupRequestBody:
      SetToolVariationsGroupRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      setToolVariationsGroupRequestBody: "SetToolVariationsGroupRequestBody",
    });
  }),
);

export function setToolsetToolVariationsGroupRequestToJSON(
  setToolsetToolVariationsGroupRequest: SetToolsetToolVariationsGroupRequest,
): string {
  return JSON.stringify(
    SetToolsetToolVariationsGroupRequest$outboundSchema.parse(
      setToolsetToolVariationsGroupRequest,
    ),
  );
}
